import React from 'react';

import { UsersWithoutComputersFilters } from './filters';

const DrawerUserWithoutComputers = () => <UsersWithoutComputersFilters />;

export default DrawerUserWithoutComputers;
